import { NgModule } from '@angular/core';
import { FormatNumberPipe } from './format-number.pipe';

@NgModule({
  imports: [],
  exports: [FormatNumberPipe],
  declarations: [FormatNumberPipe],
  providers: [],
})
export class FormattingModule {}
